import { formatNumberMix } from '@/utils'
import { _local } from '@/utils/storage'
import store from '@/store/index'
export default {
  data() { },
  methods: {
    setSiteTableConfig(data = [], reportId, offset, config, last, sort) {
      return {
        type: 'table',
        offsetLoading: false,
        offset: offset || 1,
        title: this.$t('operate-analysis::month-report::site_info'),
        ref: 'siteTable',
        height: '325px',
        last: last,
        btns: [
          { icon: 'iconicon_Import', tip: this.$t('system::function::download'), call: 'download', loading: false, reportId, target: 'siteTableConfig', title: this.$t('operate-analysis::month-report::site_info') },
          { icon: 'iconCopy-Solid', tip: this.$t('system::common::btn::copy'), call: 'copy', link: '/edit-report?isPlatformBoard=1&folderID=1&boardID=1&reportID=12425&limitSize=200&back=day-report&jump=true&isPerson=true' },
        ],
        cancelShadow: true,
        columns: Object.keys(data[0] || {}),
        tableData: config && config.tableData && config.tableData.length ? config.tableData.concat(data) : data,
        sort: config.sort || null
      }
    },
    setSaleTrendData(data, reportId) {
      return {
        type: 'lineAndBar',
        title: this.$t('sale-analysis::trend::charts_title'),
        btns: [
          { icon: 'iconicon_Import', tip: this.$t('system::function::download'), call: 'download', loading: false, reportId, target: 'saleTrendData', title: this.$t('sale-analysis::trend::charts_title') },
          { icon: 'iconCopy-Solid', tip: this.$t('system::common::btn::copy'), call: 'copy', link: '/edit-report?isPlatformBoard=1&folderID=1&boardID=1&reportID=12431&limitSize=200&back=day-report&jump=true&isPerson=true' },
        ],
        ref: 'lineAndBarChart',
        height: '308px',
        chart: {
          grid: {
            top: '10%'
          },
          legend: {
            show: true,
            data: data.legend.data
          },
          xAxis: {
            data: data.xAxis.data
          },
          yAxis: [
            {
              type: 'value',
              name: data.legend.data[0],
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              min: 0,

            },
            {
              type: 'value',
              splitLine: {
                show: false,
                lineStyle: {
                  type: 'dashed'
                }
              },
              min: 0,
              name: data.legend.data[1],
            }
          ],
          series: [
            ...data.series
          ]
        }
      }
    },
    setMonthCount(data) {
      let list = new Array(4).fill(null)
      list[0] = {
        title: `${this.$t('operate-analysis::month-report::order_deal_total')}(USD)`,
        // current: data.currency,
        tab: 1,
        noDetail: true,
        count: data && this.$dataCheck(formatNumberMix(data.grandTotalUsd, 2, ',')),
        down: data && data.grandTotalUsdRatio ? data.grandTotalUsdRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.grandTotalUsdRatio, 2, '', '')),
        tooltip: ""
      }
      list[1] = {
        title: `${this.$t('operate-analysis::month-report::spend')}(USD)`,
        tab: 1,
        // current: data.currency,
        noDetail: true,
        count: data && this.$dataCheck(formatNumberMix(data.marketSpend, 2, ',')),
        down: data && data.marketSpendRatio ? data.marketSpendRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.marketSpendRatio, 2, '', '')),
        tooltip: ''
      }
      list[2] = {
        title: this.$t('operate-analysis::month-report::profit'),
        tab: 1,
        tipTargetElemnt: '#boardShowWrap .month-report-wrap',
        visible: Boolean(isNaN((_local.get('report_local') || {}).monthReport) ? 1 : (_local.get('report_local') || {}).monthReport),
        tipCallback: (data) => {
          data.visible = !data.visible
          let local = _local.get('report_local') || {}
          local.monthReport = Number(data.visible)
          store.dispatch('updateUserInfoConfig', local)
        },
        tooltipContent: h => h('span', [
          this.$t('operate-analysis::month-report::profit_tip_info', { pixed: 38 }),
          h(
            'a',
            {
              on: {
                click: () => {
                  this.$router.push('/operate-config')
                }
              }
            },
            this.$t('menu::config-manager::operate-config')
          ),
          this.$t('operate-analysis::month-report::profit_tip_info_config')
        ]),
        count: data && this.$dataCheck(formatNumberMix(data.grossProfit, 2, '', '%')),
        down: data && data.grossProfitRatio ? data.grossProfitRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.grossProfitRatio, 2, '', '')),
        tooltip: this.$t('operate-analysis::month-report::profit_tip', { pixed: data.predictRate || 38 })
      }
      list[3] = {
        title: this.$t('operate-analysis::month-report::order'),
        tab: 1,
        noDetail: true,
        count: data && this.$dataCheck(formatNumberMix(data.orderNum, 0, ',')),
        down: data && data.orderNumRatio ? data.orderNumRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.orderNumRatio, 2, '', '')),
        tooltip: ''
      }
      list[4] = {
        title: this.$t('operate-analysis::month-report::custom_order'),
        tab: 1,
        noDetail: true,
        count: data && this.$dataCheck(formatNumberMix(data.customerPrice, 2, ',')),
        down: data && data.customerPriceRatio ? data.customerPriceRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.customerPriceRatio, 2, '', '')),
        tooltip: ''
      }
      return list
    },
    setSalesTableConfig(data = [], reportId, offset, config, last, sort) {
      return {
        title: this.$t('operate-analysis::month-report::goods_sale_top'),
        ref: 'salesTable',
        height: '325px',
        offsetLoading: false,
        offset: offset || 1,
        last: last,
        cancelShadow: true,
        btns: [
          { icon: 'iconicon_Import', tip: this.$t('system::function::download'), call: 'download', loading: false, reportId, target: 'salesTable', title: this.$t('operate-analysis::month-report::goods_sale_top') },
          { icon: 'iconCopy-Solid', tip: this.$t('system::common::btn::copy'), call: 'copy', link: '/edit-report?isPlatformBoard=1&folderID=1&boardID=1&reportID=12430&limitSize=200&back=day-report&isData=true&jump=true' },
        ],
        columns: Object.keys(data[0] || {}),
        tableData: config && config.tableData && config.tableData.length ? config.tableData.concat(data) : data,
        sort: config.sort || null
      }
    },
    setOptimizerTableConfig(data = [], reportId, offset, config, last,) {
      return {
        type: 'table',
        offsetLoading: false,
        offset: offset || 1,
        last: last,
        title: this.$t('operate-analysis::month-report::优化师投放排行榜'),
        ref: 'optimizerTable',
        height: '325px',
        btns: [
          { icon: 'iconicon_Import', tip: this.$t('system::function::download'), call: 'download', loading: false, reportId, target: 'siteTableConfig', title: this.$t('operate-analysis::month-report::site_info') },
          { icon: 'iconCopy-Solid', tip: this.$t('system::common::btn::copy'), call: 'copy', link: '/edit-report?isPlatformBoard=1&folderID=1&boardID=1&reportID=13050&limitSize=200&back=day-report&jump=true&isPerson=true' },
        ],
        cancelShadow: true,
        columns: Object.keys(data[0] || {}),
        tableData: config && config.tableData && config.tableData.length ? config.tableData.concat(data) : data,
        sort: config.sort || null
      }
    },


  }
}
